<template>
  <DefaultLayout
    :pageProps="{
      title: 'Success, your password was successfully changed!',
      description: 'Click below to get back into your Loop app!',
    }"
  >
    <template #content>
      <div style="display: flex; flex-direction: column; gap: 20px">
        <SubmitButton
          class="mt-5"
          text="Get back into the app!"
          @click.native="backToTheApp"
        />
      </div>
    </template>
  </DefaultLayout>
</template>

<script>
import SubmitButton from "@/components/buttons/SubmitButton";
import { logging } from "@/api/logs";
import { mix_panel } from "@/services/common/mixpanel";
import DefaultLayout from "@/layout/DefaultLayout.vue";
export default {
  name: "success",
  components: {
    DefaultLayout,
    SubmitButton,
  },
  methods: {
    async backToTheApp() {
      logging.sendLog("Back to the app clicked", 3);
      await mix_panel.onBasicEvent("BackToAppClicked", "");
      window.location = "intheloop://close-web-onboarding";
    },
  },
};
</script>
